












































import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';
import { ShopListItem, ProductItem } from '@tt4b/ttam-enums';
import ALink from '@/components/common/a-link/a-link.vue';
import { useJumpCatalog } from '@tt4b/ttam-hooks';

const name = 'ttam-product-details-select-product-select';
export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    shopInfo: {
      type: Object as PropType<ShopListItem>,
      default: () => ({}),
    },
    product: {
      type: Object as PropType<ProductItem>,
      default: () => ({}),
    },
    isSingleSelect: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ALink,
  },
  setup(props, { emit }) {
    const { value, shopInfo, product } = toRefs(props);
    const isSelected = computed({
      get: () => value.value,
      set: val => {
        emit('change');
      },
    });

    const catalogId = computed(() => shopInfo.value.platform_id);
    const bcId = computed(() => shopInfo.value.bc_id);
    const { jumpProductPage } = useJumpCatalog(catalogId, bcId);
    return {
      isSelected,
      name,
      jumpProductPage: () => jumpProductPage({ spu_id: product.value.spu_id }),
    };
  },
});
